/* ==========================================================================
   Carousel config data
   ========================================================================== */

/* Config */
const config = {
    component: 'Carousel',
    init: true,
    isMulti: true,
    hasPagination: false,
    hasNavigation: true,
    hasBreakpoints: true,
    hasMousewheel: false,
    hasAutoplay: false,
    hasController: false,
    navigation: {
        prev: 'angle-left',
        next: 'angle-right'
    },
    css: {
        slide: 'carousel__slide'
    }
};

/* Exports */
module.exports = () => config;
